<div class="positioning-actions">
  @if (!isFirst()) {
    <button matIconButton matTooltip="Move Up" class="settings-btn" (click)="onMoveUp()">
      <fa-icon [icon]="faArrowUp"></fa-icon>
    </button>
  }
  @if (!isLast()) {
    <button matIconButton matTooltip="Move Down" class="settings-btn" (click)="onMoveDown()">
      <fa-icon [icon]="faArrowDown"></fa-icon>
    </button>
  }
  <button matIconButton matTooltip="Jump To" class="settings-btn" (click)="onJumpTo()">
    <fa-icon [icon]="faBarsStaggered"></fa-icon>
  </button>
</div>
